import type { BannerSettings } from './types.tsx';

export const RESOURCE_ASSETS_NAVIGATION_SETTINGS = 'RESOURCE_ASSETS_NAVIGATION_SETTINGS';
export const RESOURCE_ASSETS_NAVIGATION_SETTINGS_KEY = 'assets-navigation-settings';

export const RESOURCE_ASSETS_BANNER_SETTINGS = 'RESOURCE_ASSETS_BANNER_SETTINGS';
export const RESOURCE_ASSETS_BANNER_SETTINGS_KEY = 'assets-banner-settings';

export const DEFAULT_HIGHLIGHT_COLOR = '#0052CC';
export const DEFAULT_BACKGROUND_COLOR = '#FFFFFF';

export const NAVIGATION_SETTINGS_KEYS = {
	BG_COLOR: 'assets.navigation.bgcolour',
	HIGHLIGHT_COLOR: 'assets.navigation.highlightcolour',
} as const;

export const DATE_TIME_SETTINGS_KEYS = {
	TIMEZONE: 'assets.timezone',
} as const;

export const RESOURCE_TYPE_WORKSPACE_CONTEXT = 'JSM_INSIGHT_WORKSPACE_CONTEXT';

// Cache duration for assets admin settings (15 minutes)
export const ASSETS_ADMIN_SETTINGS_MAX_AGE: number = 15 * 60 * 1000;

export const emptyNavigationSettingsResponse = {
	backgroundColor: '',
	highlightColor: '',
	timezone: '',
};

export const emptyBannerSettingsResponse: BannerSettings = {
	id: '',
	content: {
		version: 1,
		type: 'doc',
		content: [],
	},
	isDismissable: false,
	isEnabled: false,
	hashId: '',
	visibility: '',
	bgColor: '',
};
